import { render, staticRenderFns } from "./AuditLogBox.vue?vue&type=template&id=46b38518&"
import script from "./AuditLogBox.vue?vue&type=script&lang=js&"
export * from "./AuditLogBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports